import { organizerInvitedYou } from 'owa-locstrings/lib/strings/organizerinvitedyou.locstring.json';
import { principalIsOrganizer, organizerInvitedPrincipal } from './OrganizerData.locstring.json';
import { youAreOrganizer } from 'owa-locstrings/lib/strings/youareorganizer.locstring.json';
import loc, { formatToArray } from 'owa-localize';
import * as React from 'react';
import { observer } from 'mobx-react-lite';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';

import PersonaName from './PersonaName';

export interface OrganizerDataProps {
    organizer: EmailAddressWrapper;
    isOrganizer: boolean;
    invitee: EmailAddressWrapper;
}

const OrganizerData: React.FunctionComponent<OrganizerDataProps> = observer(props => {
    const { organizer, isOrganizer, invitee } = props;

    if (isOrganizer && !invitee) {
        return <span className={'allowTextSelection'}>{loc(youAreOrganizer)}</span>;
    }

    const organizerControl = getPersonControl(organizer);

    // Principal is the organizer
    if (isOrganizer && invitee) {
        return <>{formatToArray(loc(principalIsOrganizer), organizerControl)}</>;
    }

    // Principal is an attendee
    if (!isOrganizer && invitee) {
        const inviteeControl = getPersonControl(invitee);
        return (
            <>{formatToArray(loc(organizerInvitedPrincipal), organizerControl, inviteeControl)}</>
        );
    }

    // User is an attendee
    return <>{formatToArray(loc(organizerInvitedYou), organizerControl)}</>;
});

export default OrganizerData;

function getPersonControl(person: EmailAddressWrapper): JSX.Element {
    return <PersonaName name={person.Name} emailAddress={person.EmailAddress} />;
}
